import * as translationsDE from '@/languages/language.de_DE.json';
import * as translationsEN from '@/languages/language.en_EN.json';
import * as translationsFR from '@/languages/language.fr_FR.json';

import angular from 'angular';

angular
    .module('webmailWrapper')
    .filter('translate', function (translationProvider, util) {

        return function(key) {

            if (key.includes('.')) {
                return util.getValueAtPathOfObject(translationProvider.getAllTranslations(), key);
            }
            return translationProvider.getTranslation(key);
        }
    })

angular
    .module('webmailWrapper')
    .service('translationProvider', function (util, entryPointProvider, $interpolate, $rootScope) {

        var lang = entryPointProvider.defaultLang;

        switch (lang) {
            case 'de_DE':
                var keyValuePairsArray = JSON.parse(JSON.stringify(translationsDE));
                break;
            case 'fr_FR':
                var keyValuePairsArray = JSON.parse(JSON.stringify(translationsFR));
                break;
            case 'en_EN':
            default:
                var keyValuePairsArray = JSON.parse(JSON.stringify(translationsEN));
        }

        this.getTranslation = function(key) {
            return keyValuePairsArray[key];
        }

        this.getAllTranslations = function() {
            return keyValuePairsArray;
        }

        this.instant = function(key, singleParam=undefined, multipleParams=undefined) {
            var translation;

            if (key.includes('.')) {
                translation = util.getValueAtPathOfObject(this.getAllTranslations(), key);
            } else {
                translation = this.getTranslation(key);
            }
            if (singleParam !== undefined) {
                translation = translation.replace(/\{\{\s*[^}]+\s*\}\}/g, singleParam);
            }
            let scope = $rootScope;
            if (!scope) {
                scope = {};
            }
            let paramsProps = [];
            if (multipleParams) {
                paramsProps = Object.getOwnPropertyNames(multipleParams);
            }
            if (paramsProps.length > 0) {
                for (const element of paramsProps) {
                    scope[element] = multipleParams[element];
                }
                return $interpolate(translation)(scope);
            }

            return translation || key;
        }
    })
